import React from "react";
import {CarouselNews} from "./CarouselNews";
import {Shortcuts} from "./Shortcuts";
import {Banner} from "./Banner";

export const IzziHome = () => {
    const SECCION_ID = 1;

    return (
        <section>
            <Banner/>
            <div className="mt-4">
                <CarouselNews seccionId={SECCION_ID}/>
            </div>
            <Shortcuts/>
        </section>
    );
};
